/* unplugin-vue-components disabled */import { render } from "./textareaEditor.vue?vue&type=template&id=cff245aa"
import script from "./textareaEditor.vue?vue&type=script&lang=js"
export * from "./textareaEditor.vue?vue&type=script&lang=js"

import "./textareaEditor.vue?vue&type=style&index=0&id=cff245aa&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__